import React, { useState, useMemo, Suspense } from 'react'

import { HistoryList } from './parts/HistoryList'
import { ListSkeleton } from '@/components/ListSkeleton'
import ErrorPage from '@/pages/Error'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { FilterBar } from '@/components/FilterBar'
import { ChargingFilterBottomSheet } from './parts/ChargingFilterBottomSheet'
import { useDisclosure } from '@/hooks/useDisclosure'
import { ChargingHistoryFilters } from '@/api/charging/types'
import { useQueryChargingHistoryStations } from '@/api/charging/queries'

const HistoryTab: React.FC = () => {
  const [filters, setFilters] = useState<ChargingHistoryFilters>({})
  const { isOpen: showFilters, open: openFilters, close: closeFilters } = useDisclosure()

  const { data: stationsData } = useQueryChargingHistoryStations()
  const stations = useMemo(
    () => stationsData?.results.map((s) => s.name) ?? [],
    [stationsData]
  )

  const activeFilterKeys = useMemo(
    () =>
      Object.entries(filters)
        .filter(([, v]) => v !== null && v !== undefined && v !== '')
        .map(([k]) => k)
        .filter((k) => {
          if (k === 'activePeriod') return false // não conta o select de período como filtro ativo
          return true
        }),
    [filters]
  )

  const handleApplyFilters = (appliedFilters: Record<string, unknown>) => {
    setFilters(appliedFilters as ChargingHistoryFilters)
  }

  const handleClearFilters = () => {
    setFilters({})
  }

  return (
    <ErrorBoundary fallback={<ErrorPage />}>
      <Suspense
        fallback={
          <ListSkeleton.Wrapper count={3}>
            <ListSkeleton.HistoryItem />
          </ListSkeleton.Wrapper>
        }
      >
        <FilterBar
          activeFilterKeys={activeFilterKeys}
          onOpenFilters={openFilters}
          onClearFilters={handleClearFilters}
        />
        <HistoryList filters={filters} />
          <ChargingFilterBottomSheet
            filters={filters}
            onApply={handleApplyFilters}
            onClear={handleClearFilters}
            isOpen={showFilters}
            onClose={closeFilters}
            stations={stations}
          />
      </Suspense>
    </ErrorBoundary>
  )
}

export default HistoryTab
